import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { BorderedTab, BorderedTabs, Flex, FlexColumn, Heading, LinkButton, Text } from 'core/components';
import Markdown from '../../journeys/Markdown';
import ToolResultCard from '../components/ToolResultCard';

const CARD_CLASS = 'tool-result-runbooks';

/** Reusable label + value display block. */
const LabeledField = ({ label, children }) => (
  <FlexColumn gap="4px">
    <Text muted small>
      {label}
    </Text>
    {children}
  </FlexColumn>
);

@inject('$runbook')
class RunbookToolResult extends Component {
  state = { selectedTabIndex: 0 };

  handleTabChange = (index) => {
    this.setState({ selectedTabIndex: index });
  };

  get cardProps() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    return { tool, onCloseToolResult, className: CARD_CLASS, isInlineMode };
  }

  renderViewRunbookLink(runbookName) {
    const { $runbook } = this.props;
    const to = runbookName ? `${$runbook.baseUrl}?search=${encodeURIComponent(runbookName)}` : $runbook.baseUrl;
    return (
      <LinkButton small icon="book" minimal to={to}>
        View Runbook
      </LinkButton>
    );
  }

  render() {
    const { tool } = this.props;
    const { selectedTabIndex } = this.state;
    const { raw_result } = tool;

    const runbooks = raw_result || [];

    if (runbooks.length > 0) {
      const selectedRunbook = runbooks[selectedTabIndex] || runbooks[0];

      return (
        <ToolResultCard
          {...this.cardProps}
          title={tool.title || 'Runbooks'}
          overflow="hidden"
          headerActions={this.renderViewRunbookLink(selectedRunbook?.name)}
        >
          <FlexColumn gap={0} height="100%" overflow="hidden">
            {runbooks.length > 1 && (
              <Flex p={2} pt={0} pb={1} borderBottom="thin">
                <BorderedTabs selectedTabIndex={selectedTabIndex} onChange={this.handleTabChange}>
                  {runbooks.map((runbook, index) => (
                    <BorderedTab id={index} key={runbook.id || index} title={runbook.name} />
                  ))}
                </BorderedTabs>
              </Flex>
            )}

            <FlexColumn gap={2} p={2} overflow="auto" flex={1}>
              {runbooks.length === 1 && (
                <LabeledField label="Name">
                  <Heading level={4} m={0} fontSize={18} fontWeight={600}>
                    {selectedRunbook.name}
                  </Heading>
                </LabeledField>
              )}

              {selectedRunbook.description && (
                <LabeledField label="Description">
                  <Text>{selectedRunbook.description}</Text>
                </LabeledField>
              )}

              <LabeledField label="Instructions">
                <Markdown>{selectedRunbook.instructions || ''}</Markdown>
              </LabeledField>
            </FlexColumn>
          </FlexColumn>
        </ToolResultCard>
      );
    }

    return (
      <ToolResultCard {...this.cardProps} title={tool.title || 'Runbooks'} headerActions={this.renderViewRunbookLink()}>
        <FlexColumn p={2} gap={2}>
          <Text muted>No runbooks retrieved</Text>
        </FlexColumn>
      </ToolResultCard>
    );
  }
}

export default RunbookToolResult;
